import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { PageLayout } from '@thinknet-gmbh/platform-common-ui';

import { ROUTES } from 'src/components/app/app-routes.constants';
import { CompanyCommonForm } from 'src/pages/settings/components/company-profile/components/company-common-form';
import { useUpsertCompany } from 'src/hooks/companies/upsert-company.hook';

const AddSubsidiaryCompany = () => {
  const { t } = useTranslation('settings');
  const { state } = useLocation();
  const navigate = useNavigate();

  const upsertCompany = useUpsertCompany({ onSuccess: () => navigate(ROUTES.settings) });

  const handleFinish = (values: any) => {
    upsertCompany({ variables: { payload: values } });
  };

  return (
    <PageLayout pageTitle={t('company.buttons.addSubsidiaryCompany')}>
      <CompanyCommonForm
        companyData={{ parentCompanyId: state?.parentCompanyId }}
        onCancel={() => navigate(ROUTES.settings)}
        onFinish={handleFinish}
      />
    </PageLayout>
  );
};

export default AddSubsidiaryCompany;
